export default {
  title: "",
  subtitle: "Settlements and Deposit/Pre-funding",
  path: "settlements_and_deposit_prefunding",
  paragraphs: [
    "To initiate a settlement transaction and send money abroad, you need to select a bank_account_id from an internal cash_in account, which will be the source of the funds, and specify your foreign account as the destination."
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payloads: [
      {
        title: "Example of a Settlements",
        content: { 
          "transaction": { 
            "currency": "USD", 
            "exchange_currency": "USD", 
            "value": "10000.00", 
            "from_bank_account_id": "cash-in USD", 
            "to_bank_account_id": "id of your account abroad", 
            "subject_id": "your partner_id" 
          } 
        } 
      },
      {
        title: "Usage of the Settlements",
        content: {  
        "transaction": {  
            "currency": "USD",  
            "exchange_currency": "USD",  
            "value": "100000.00",  
            "from_bank_account_id": "3686155e-f5f6-4e5b-97e7-60473a506b8c",  
            "to_bank_account_id": "bce84c35-01df-4d5d-bbcd-474bb31c50c4",  
            "subject_id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2"  
            }  
        } 
      }
    ],
    responses:{ 
    "data": { 
     "value": "100000.00", 
     "to_bank_account": {
        "routing_number": null,
        "pix_info": null,
        "owner_name": null,
        "owner_document_type": null,
        "owner_document_number": null,
        "nickname": null,
        "intermediary_bank_account_id": null,
        "id": "bce84c35-01df-4d5d-bbcd-474bb31c50c4",
        "iban": null,
        "currency": "USD",
        "branch_number": null,
        "branch_country": null,
        "bank": {
            "swift": "bofaus3n",
            "name": "Bank of America",
            "ispb": null,
            "id": "d66395c6-697f-4fa5-8c75-65901d5c5ae3",
            "country": null,
            "code": null
        },
        "account_type": "conta-corrente",
        "account_number": "0139410341923409",
        "aba": null
      },
     "subject_is_receiver": true, 
     "subject_id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2", 
     "subject": { 
       "updated_at": "2025-02-19T19:28:37.690718", 
       "status": "approved", 
       "social_name": "Biri Web", 
       "rfc_pf": null, 
       "required_clearance_level": 1, 
       "references": [], 
       "phone_number": "+55 (18) 99812-1212", 
       "phone_country_code": null, 
       "phone_area_code": null, 
       "net_monthly_average_income": "4000.00", 
       "inserted_at": "2020-01-29T05:54:23.518616", 
       "id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2", 
       "fiscal_country": "Brasil", 
       "email": "gustavo.paludetto@facilitapay.com", 
       "document_type": "cpf", 
       "document_number": "21958642819", 
       "clearance_level": 1, 
       "birth_date": "1977-10-13", 
       "address_street": "Rua Antonio Pontes Filho", 
       "address_state": "SP", 
       "address_postal_code": "16201220", 
       "address_number": "310", 
       "address_neighborhood": null, 
       "address_country": "Brasil", 
       "address_complement": null, 
       "address_city": "Birigui" 
       },
     }, 
     "status": "wired", 
     "source_name": "Biri Web", 
     "source_document_type": "cpf", 
     "source_document_number": "21958642819", 
     "meta": null, 
     "inserted_at": "2025-05-13T18:46:10.623774", 
     "id": "299febc9-6420-47e8-947d-ffbabdf2768e", 
     "from_credit_card": null, 
     "from_bank_account": {
            "routing_number": null,
            "pix_info": null,
            "owner_name": "Biriweb Serviços de Internet Ltd",
            "owner_document_type": null,
            "owner_document_number": "21958642819",
            "nickname": null,
            "internal": true,
            "intermediary_bank_account_id": null,
            "id": "3686155e-f5f6-4e5b-97e7-60473a506b8c",
            "iban": null,
            "flow_type": "cash_in",
            "currency": "BRL",
            "branch_number": null,
            "branch_country": null,
            "bank": {
                "swift": null,
                "name": "Internal",
                "ispb": null,
                "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
                "country": "BRA",
                "code": "999"
            },
            "account_type": "conta-corrente",
            "account_number": null,
            "aba": null
        },
        "for_exchange": true,
        "exchanged_value": null,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "BRL",
        "cleared": true,
        "bank_transaction": {
            "wire_id": null,
            "value": "10000",
            "spei_reference": null,
            "spei_concepto_de_pago": null,
            "source_type": "TED-PRE",
            "source_name": "Biri Web",
            "source_id": "60a83ac2-acfa-41e9-b25c-5b4abbcf7612",
            "source_document_type": "cpf",
            "source_document_number": "21958642819",
            "source_description": "CREDITO POR TED ANTECIPADO",
            "source_branch": null,
            "source_bank_ispb": null,
            "source_bank": null,
            "source_account": null,
            "movement_date": "2025-07-09",
            "iof_value": null,
            "inserted_at": "2025-07-09T20:55:57.659105",
            "id": "880eec38-a0f5-4821-871c-876ed9eee652",
            "exchanged_value": null,
            "exchange_rate_spot": null,
            "exchange_rate": null,
            "exchange_id": null,
            "exchange_currency": "USD",
            "exchange_approved": false,
            "currency": "BRL"
        }
   } 
 },
 troubleshooting: {
    title: 'Common mistakes',
    messages: [
       {
        description: 'Invalid currency to destination account',
        code:{
              "errors": {
                  "to_bank_account_id": [
                      "account currency does not match transaction exchange_currency"
                  ]
              }
          },
        solution: 'Provide a valid currency or changes the id of your account abroad'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionSettlements.js